// extracted by mini-css-extract-plugin
export var bodyRow = "_h8-d";
export var cardColumns = "_h8-e";
export var ellipsesOverflow = "_h8-2";
export var flatBottomCorners = "_h8-3";
export var flatTopCorners = "_h8-4";
export var headerActionsDropdown = "_h8-f";
export var headerBottomRow = "_h8-c";
export var headerTopRow = "_h8-b";
export var orderDetailsWrapper = "_h8-0";
export var orderInfoContainer = "_h8-1";
export var productDetails = "_h8-9";
export var productImage = "_h8-5";
export var responsiveTable = "_h8-8";
export var shipmentContainer = "_h8-a";
export var tableBottomLeft = "_h8-6";
export var tableBottomRight = "_h8-7";
export var trackingLink = "_h8-g";